const UsersStatusEnum = {
  Registration: 'registration',
  Survey: 'survey',
  Pending: 'pending',
  Approved: 'approved'
}

export default UsersStatusEnum;